import { useState } from 'react';
import { Button, Flex } from '@radix-ui/themes';
import { MetadataEditorPanel } from './MetadataEditorPanel';
import { MetadataHistoryPanel } from './MetadataHistoryPanel';

export const MetadataToolbar = () => {
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);

    return (
        <>
            <Flex gap='3'>
                <Button
                    variant='surface'
                    color='gray'
                    highContrast
                    onClick={() => setIsHistoryOpen(true)}
                >
                    Voir l'historique
                </Button>

                <Button onClick={() => setIsEditorOpen(true)}>
                    Éditer les métadonnées
                </Button>
            </Flex>

            <MetadataEditorPanel
                open={isEditorOpen}
                onClose={() => setIsEditorOpen(false)}
            />

            <MetadataHistoryPanel
                open={isHistoryOpen}
                onClose={() => setIsHistoryOpen(false)}
            />
        </>
    );
};
